





















































import { Component, Watch, Mixins } from "vue-property-decorator";
import _ from "@/boot/lodash";

// Mixins
import PaymentProvidersInjectorMixin from "@/mixins/paymentProvidersInjectorMixin";

// Types
import { ISortableOptions } from "@/models/reordering";

@Component({
  components: {
    "payment-providers-list-item": () =>
      import(
        "@/components/app/admin/settings/paymentProviders/paymentProvidersListItem.vue"
      )
  }
})
export default class AssignedPaymentProvidersListing extends Mixins(
  PaymentProvidersInjectorMixin
) {
  // Data

  public sortableOptions: ISortableOptions = {
    chosenClass: "dragged-vessel",
    handle: ".vessel-draggable"
  };
  public sortElems: any[] = [];
  public savedOrder: any[] = [];
  public isReordering = false;

  public searchQuery = "";
  public debounceSearch = this.$_.debounce(this.doQuickSearch, 250);

  public async doQuickSearch(value = "") {
    if (value === this.searchQuery) return;
    this.searchQuery = value;
  }

  // Computed

  public get showEmptyState() {
    return (
      (!this.paymentProvidersData.isLoading && this.noPaymentProviders) ||
      (this.searchQuery && !this.paymentProviders.length)
    );
  }

  public get skeletonSize() {
    return this.$store.getters["ui/isMobile"] ? 2 : 5;
  }

  public get noPaymentProviders() {
    return !this.paymentProvidersData.paymentProviders.length;
  }

  public get paymentProviders() {
    return _.filter(this.paymentProvidersData.paymentProviders, provider => {
      if (!this.searchQuery.length) return true;

      const searchQuery = this.searchQuery.toLowerCase();
      const checkedValues = [
        provider.name.toLowerCase(),
        _.get(provider, "name_translated", "").toLowerCase(),
        provider.gateway_provider.name.toLowerCase(),
        _.get(provider, "gateway_provider.name_translated", "").toLowerCase()
      ];

      _.forEach(provider.currencies, currency => {
        checkedValues.push(currency.currency_code.toLowerCase());
      });

      _.forEach(provider.countries, country => {
        checkedValues.push(country.code.toLowerCase());
        checkedValues.push(country.name.toLowerCase());
      });

      return _.some(checkedValues, checkedValue =>
        checkedValue.includes(searchQuery)
      );
    });
  }

  // Methods

  public async onDragDrop() {
    try {
      this.isReordering = true;
      await this.$paymentProvidersMethods.reorder(
        this.$_.map(this.sortElems, sortElem => sortElem.id)
      );
      await this.$paymentProvidersMethods.reloadData();
      this.$store.dispatch("toast/show", {
        message: this.$t("_.payment_providers_order_changed")
      });
    } catch (error) {
      this.$store.dispatch("api/handleError", error);
    } finally {
      this.isReordering = false;
    }
  }

  // Watchers

  @Watch("paymentProvidersData.paymentProviders", { immediate: true })
  public onPaymentProvidersChange() {
    this.sortElems = this.$_.cloneDeep(
      this.paymentProvidersData.paymentProviders
    );
    this.savedOrder = this.$_.cloneDeep(this.sortElems);
  }
}
